export default {
	project_name: 'TCL Experts',
	point: 'Star | Stars',
	points: 'Stars',
	point_plural: 'Stars',
	score: 'Stars',
	points_earned: 'Earned Stars',
	my_points: 'My Stars',
	points_table: 'Stars Table',
	acc_score: 'Accumulated Star | Accumulated Stars',
}
